export default function HeroSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e0d8eeb1541ede9d6d624dc7999a13f6.jpg"
          alt="Clínica Primor Odontologia"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 via-primary-700/80 to-primary-600/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-5 md:px-6 pt-28 pb-20 md:py-32 flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 bg-secondary/20 border border-secondary/40 text-secondary-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 animate-fade-in">
          <i className="ri-shield-check-line"></i>
          Aprovação de crédito na hora
        </span>

        <h2 className="text-3xl md:text-6xl font-extrabold text-white leading-tight max-w-3xl mb-4 md:mb-6 animate-fade-up">
          Sorrir com qualidade nunca foi tão{" "}
          <span className="text-secondary-300">acessível</span>
        </h2>

        <p className="text-sm md:text-xl text-white/80 max-w-2xl mb-7 md:mb-10 animate-fade-up px-2">
          Clínica odontológica moderna com preços acessíveis e pagamento
          facilitado — tratamento de qualidade para todos.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 items-stretch sm:items-center animate-fade-up w-full sm:w-auto">
          <a
            href="https://wa.me/5511999999999?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta%20na%20Primor%20Odontologia!"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center justify-center gap-3 bg-secondary hover:bg-secondary-500 text-white font-bold px-7 py-4 rounded-full text-sm transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar no WhatsApp
          </a>

          <a
            href="#contato"
            onClick={(e) => { e.preventDefault(); scrollTo("#contato"); }}
            className="flex items-center justify-center gap-3 bg-white/15 hover:bg-white/25 border border-white/40 text-white font-bold px-7 py-4 rounded-full text-sm transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            Agendar Consulta
          </a>
        </div>

        {/* Stats bar */}
        <div className="mt-10 md:mt-20 flex items-stretch bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl w-full max-w-sm sm:max-w-lg md:max-w-2xl overflow-hidden">
          {[
            { value: "+700", label: "Pacientes atendidos" },
            { value: "100%", label: "Crédito aprovado" },
            { value: "+2 anos", label: "De experiência" },
          ].map((stat, i) => (
            <div key={stat.label} className={`flex-1 text-center py-4 px-2 md:py-6 md:px-6 ${i < 2 ? "border-r border-white/20" : ""}`}>
              <p className="text-lg sm:text-2xl md:text-3xl font-extrabold text-secondary-300 leading-none">{stat.value}</p>
              <p className="text-[10px] sm:text-xs text-white/70 mt-1 leading-tight">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 text-white/60 animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}